import { render, staticRenderFns } from "./allMsg.vue?vue&type=template&id=f495abb0&scoped=true&"
import script from "./allMsg.vue?vue&type=script&lang=js&"
export * from "./allMsg.vue?vue&type=script&lang=js&"
import style0 from "./allMsg.vue?vue&type=style&index=0&id=f495abb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f495abb0",
  null
  
)

export default component.exports